// Base bucket name (from Firebase Console → Storage)
export const FIREBASE_STORAGE_BUCKET = 'boesensteinproject.firebasestorage.app';

// Base URL for file access via Firebase Storage REST
export const FIREBASE_STORAGE_BASE_URL = `https://firebasestorage.googleapis.com/v0/b/${FIREBASE_STORAGE_BUCKET}/o`;

// Helper to build a public URL for a given object path, e.g. "other/tattooLogo.svg"
export function buildStorageUrl(objectPath) {
  // objectPath example: "other/tattooLogo.svg"
  const encodedPath = encodeURIComponent(objectPath);
  return `${FIREBASE_STORAGE_BASE_URL}/${encodedPath}?alt=media`;
}
